import { type Transcription } from '@klangio/ai2notes-ts-client';
import { SheetSourceType, TranscriptionState } from '../entities/transcription';

// eslint-disable-next-line import/prefer-default-export
export const getErrorMessage = (error: number, source: string, t: any) => {
  switch (error) {
    case 1001:
      if (source === SheetSourceType.YouTube) {
        return t('file.error.yt_not_available');
      }
      return t('file.error.invalid_file_format');

    case 2001:
      return t('file.error.yt_not_available');
    case 3001:
      return t('file.error.no_notes_found');
    case 0:
    default:
      return t('file.error.unknown');
  }
};

/**
 * Return true if transcription is undefined, null or has failed.
 * @param {Transcription} transcription
 * @returns true, if transcriptino is undefined, null or has failed. Else false.
 */
export const hasFailed = (transcription: Transcription) => {
  if (!transcription) return false;
  return (
    transcription.state === TranscriptionState.Error
    || (transcription.error !== null && transcription.state === TranscriptionState.Refunded)
  );
};
